import { useQuery } from "@tanstack/react-query";

import type { IAppsFilterOptionsDto } from "app/pages/sales-intelligence/domain/apps/types/filter-options";
import type { IAppsSdkDescriptionItemDto } from "app/pages/sales-intelligence/domain/sdk/types/dto";

import { createAppsFilterDescriptionQuery } from "./options";

const selectSdkDescriptions = ({ sdksFilter }: IAppsFilterOptionsDto): readonly IAppsSdkDescriptionItemDto[] =>
    sdksFilter.sdksDescriptions;

type UseSdkDescriptionsQueryOptions = {
    enabled?: boolean;
};

export default function useSdkDescriptionsQuery({ enabled }: UseSdkDescriptionsQueryOptions = {}) {
    return useQuery(createAppsFilterDescriptionQuery({ select: selectSdkDescriptions, enabled }));
}
